import { formattedColorMaterial } from "../../components/formatted/FormattedText";

export const buildMaterialListFromDetectedObjects = (detectedObjects, t) => {
  if (!Array.isArray(detectedObjects) || detectedObjects.length === 0) {
    return [];
  }

  const materials = [];

  detectedObjects.forEach((annotation) => {
    if (!annotation?.cls) {
      return;
    }

    const materialValue = annotation.cls.toLowerCase();
    const materialName = t(materialValue);
    const existingIndex = materials.findIndex(
      (item) => item.value === materialValue,
    );

    if (existingIndex === -1) {
      materials.push({
        name: materialName,
        value: materialValue,
        color: formattedColorMaterial(materialValue),
        count: 1,
        nameAndCount: `${materialName} (1)`,
      });
      return;
    }

    const nextCount = materials[existingIndex].count + 1;
    materials[existingIndex] = {
      ...materials[existingIndex],
      count: nextCount,
      nameAndCount: `${materialName} (${nextCount})`,
    };
  });

  return materials;
};
